import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { Typography } from '@material-ui/core';
import { Skeleton } from '@material-ui/lab';

import {
  AGE_GROUP_APPEAL,
  getAgeHistogramAppeal,
  getGenderHistogramTone,
} from 'src/data/demographics';
import { HistogramAge } from 'src/components/HistogramAge';
import { HistogramGender } from 'src/components/HistogramGender';
import { getAgeTitle, getGenderTitle } from './utils';
import { useStyles } from './useStyles';

export const Histograms = ({
  className,
  dataAge,
  dataGender,
  score,
  noneAppeal,
  loading,
}) => {
  const styles = useStyles();

  const ageAppeal = useMemo(() => getAgeHistogramAppeal(dataAge || []), [
    dataAge,
  ]);
  const ageTitle = getAgeTitle(score, noneAppeal, ageAppeal);

  const genderTone = useMemo(() => getGenderHistogramTone(dataGender || []), [
    dataGender,
  ]);
  const genderTitle = getGenderTitle(genderTone);

  return (
    <div className={cx(styles.root, className)}>
      <div className={styles.column}>
        <Typography className={styles.title}>{ageTitle}</Typography>

        <div className={styles.wrapperAge}>
          {loading ? (
            <Skeleton variant="rect" height="100%" />
          ) : (
            <HistogramAge
              data={dataAge}
              forcedAppeal={noneAppeal ? AGE_GROUP_APPEAL.none : null}
            />
          )}
        </div>
      </div>

      <div className={styles.column}>
        <Typography className={styles.title}>{genderTitle}</Typography>

        <div className={styles.wrapperGender}>
          {loading ? (
            <Skeleton variant="rect" height="100%" />
          ) : (
            <HistogramGender data={dataGender} />
          )}
        </div>
      </div>
    </div>
  );
};

Histograms.propTypes = {
  className: PropTypes.string,
  dataAge: PropTypes.arrayOf(PropTypes.shape()),
  dataGender: PropTypes.arrayOf(PropTypes.shape()),
  score: PropTypes.number,
  noneAppeal: PropTypes.bool,
  loading: PropTypes.bool,
};

Histograms.defaultProps = {
  className: null,
  dataAge: null,
  dataGender: null,
  score: 0,
  noneAppeal: false,
  loading: false,
};
